/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";

export default function PinningActionBar({
  isCancelDisabled = false,
  variant = "absolute",
  onCancel,
  onEscapeHatchClick,
  ...restProps
}: any) {
  return (
    <div
      {...restProps}
      className={cn(
        "flex items-center justify-between bg-white p-2 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]",
        restProps.className,
        variant === "absolute" ? "absolute bottom-0 left-0 right-0 z-10" : "shrink-0"
      )}
      data-testid="pinning-artboard-actions"
    >
      <div className="flex items-center">
        <button
          className="text-gray-400! hover:text-gray-500! [font-family:inherit]! text-sm! cursor-pointer border-none bg-transparent p-0 font-normal hover:underline"
          type="button"
          data-testid="escape-hatch-button"
          onClick={() => {
            onEscapeHatchClick?.();
          }}
        >
          {" "}
          Use classic edit form{" "}
        </button>
      </div>
      <div className="flex shrink-0 items-center gap-2.5">
        <button
          className="flex shrink-0 cursor-pointer items-center gap-1.5 rounded-[8px] border border-[#414192] bg-white px-3.5 py-2 text-base font-semibold [font-family:inherit] disabled:pointer-events-none disabled:opacity-25"
          type="button"
          style={{ color: "#414192" }}
          disabled={isCancelDisabled}
          data-testid="pinning-cancel"
          onClick={() => {
            onCancel?.();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            data-testid="pinning-action-bar-svg"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" x2="9" y1="12" y2="12" />
          </svg>{" "}
          Exit{" "}
        </button>
      </div>
    </div>
  );
}
